import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Language } from '@future-harry/nxt-vue-library';

export const useLanguagesStore = defineStore('languages', () => {
   const allLanguages = ref<Language[]>([]);

   const allLanguagesOptionsFormat = computed(() =>
      allLanguages.value.map((l) => ({
         ...l,
         name: l.name_translation,
      })),
   );

   function setLanguages(languages: Language[]) {
      allLanguages.value = languages;
   }

   return {
      allLanguages,
      setLanguages,
      allLanguagesOptionsFormat,
   };
});
